var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 100,
    viewBox: "0 0 90 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_2144)",
    filter: "url(#filter0_i_54_2144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3906 41.4155L39.6531 31.4436L31.0438 25.0269H41.5563L45 14.7082L48.3531 25.0269H58.9563L50.3469 31.4436L53.5188 41.4155L45 35.2589L36.3906 41.4155ZM23.6125 84.8342V47.3119C20.8938 44.5949 18.9453 41.6179 17.7672 38.3806C16.5891 35.1433 16 31.8772 16 28.5821C16 20.7203 18.7792 14.1301 24.3375 8.81174C29.8959 3.49339 36.7834 0.834229 45 0.834229C53.2166 0.834229 60.1041 3.49339 65.6625 8.81174C71.2209 14.1301 74 20.7203 74 28.5821C74 31.8772 73.4109 35.1433 72.2328 38.3806C71.0547 41.6179 69.1063 44.5949 66.3875 47.3119V84.8342L45 66.2854L23.6125 84.8342ZM45 51.1273C51.5854 51.1273 57.1588 48.9451 61.7203 44.5805C66.2818 40.2159 68.5625 34.8831 68.5625 28.5821C68.5625 22.2811 66.2818 16.9483 61.7203 12.5837C57.1588 8.2192 51.5854 6.03696 45 6.03696C38.4146 6.03696 32.8412 8.2192 28.2797 12.5837C23.7182 16.9483 21.4375 22.2811 21.4375 28.5821C21.4375 34.8831 23.7182 40.2159 28.2797 44.5805C32.8412 48.9451 38.4146 51.1273 45 51.1273Z",
    fill: "#767676",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_54_2144",
    x: 0,
    y: 0.638916,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_54_2144"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0 0.638916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchTag);
export default __webpack_public_path__ + "static/media/batchTag.0d2b0f28bd414267551899ef225a34fc.svg";
export { ForwardRef as ReactComponent };